import { Alert } from '@coreui/coreui';
import $axios from 'src/utils/axios';
import IP from 'src/StoreGlobal/IP';

let companyId = parseInt(localStorage.getItem('company_id'));
let accessToken = localStorage.getItem('token');
let user_id = parseInt(localStorage.getItem('user_id'));

export const EquipmentRequestHistoryDetailsEdit = (data) => {
  return $axios.put(`equipment/request-history/details/edit`, {
    ...data,
  });
};

export const EquipmentRequestHistoryEdit = (companyId, projectId, data) => {
  return $axios.put(`equipment/request-history/${companyId}/${projectId}`);
};

export const GetTotalFuelOrder = (projectId) => {
  return $axios.get(`equipment/fuel/total-order/${projectId}`);
};

// Equipment Module

export const GetEquipmentMasterList = (page = 1, per_page = 10, search = '', archived = null) => {
  return $axios.get(`equipment/list?page=${page}&per_page=${per_page}&search=${search}&archived=${archived}`);
};

export const getEquipmentCategory = (page = 1, limit = 10, search_category = '') => {
  const encodedSearchCategory = encodeURIComponent(search_category);
  return $axios.get(`equipment/category/list?page=${page}&limit=${limit}&search_category=${encodedSearchCategory}`);
};

export const getEquipmentCategoryListV2 = ({ page = 1, per_page = 10, search = '' }) => {
  return $axios.get(`equipment/type/list?page=${page}&per_page=${per_page}&search=${search}`);
};

export const archiveAllEquipment = () => {
  const data = { type_id: 3 };
  return $axios.post(`project/archive/bulk`, data);
};

export const GetByProjectEquipment = (page = 1, page_size = 10) => {
  return $axios.get(`equipment/master/list/details?page=${page}&page_size=${page_size}`);
};

export const postEquipmentUpload = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return $axios.post('/equipment/upload/new', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getSampleFormat = async () => {
  const Swal = require('sweetalert2');
  try {
    const response = await $axios.post(`equipment/download/format/new`, {}, { responseType: 'blob' });
    const url_2 = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
    const link = document.createElement('a');
    link.href = url_2;
    link.setAttribute('download', `Equipment_Format.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error('Error downloading report:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Something went wrong...',
      confirmButtonColor: '#23303D',
    });
  }
};

export const GetEquipmentTypes = () => {
  return $axios.get('/equipment/types');
};

export const RestoreArchive = (brand_id) => {
  return $axios.put(`equipment/archive/${brand_id}`)
}

export const GetCategoryList = (inputValue) => {
  return $axios.get('equipment/category/list', {
    params: {
      search_category: inputValue,
    }
  })
}

export const GetWarehouseList = ({ page = 1, per_page = 10, search = '' }) => {
  return $axios.get(`company/warehouse/list?page=${page}&per_page=${per_page}&search=${search}`);
}

export const EquipmentWarehouseAdd = (data) => {
  return $axios.post(`company/warehouse/create`, data);
}

export const EquipmentWarehouseEdit = (data) => {
  return $axios.post(`company/warehouse/update`, data);
}

export const EquipmentWarehouseDelete = (data) => {
  return $axios.post(`company/warehouse/delete`, data);
}

export const EquipmentAssignList = ({ projectId, page = 1, per_page = 10 }) => {
  return $axios.get(`/equipment/list/assign?project_id=${projectId}&page=${page}&per_page=${per_page}`)
}

export const EquipmentInfo = ({ projectID, equipmentID }) => {
  const company_id = parseInt(localStorage.getItem('company_id'));
  return $axios.get(`equipment/project/details/${company_id}/${projectID}?id=${equipmentID}`);
}

export const EquipmentAssignCreate = (data) => {
  return $axios.post(`equipment/assign/create`, { data });
}

export const EquipmentBrandList = ({ page = 1, per_page = 10, search = '' }) => {
  return $axios.get(`equipment/brand/list?page=${page}&per_page=${per_page}&search=${search}`);
}

export const CreateEquipmentBrand = (data) => {
  return $axios.post(`equipment/brand/create`, data)
}

export const DeleteEquipmentBrand = (data) => {
  return $axios.post(`equipment/brand/delete`, data)
}

export const UpdateEquipmentBrand = (data) => {
  return $axios.post(`equipment/brand/update`, data)
}

export const AddEquipmentList = (data) => {
  return $axios.post(`equipment/create`, data)
}

export const UpdateEquipmentList = (data) => {
  return $axios.post(`equipment/update`, data)
}

export const GetEquipmentModelList = ({ page = 1, per_page = 10, search = '' }) => {
  return $axios.get(`equipment/model/list?page=${page}&per_page=${per_page}&search=${search}`);
}

export const CreateEquipmentModel = (data) => {
  return $axios.post(`equipment/model/create`, data)
}

export const GetEquipmentTypeList = ({ page = 1, per_page = 10, search = '' }) => {
  return $axios.get(`/equipment/masterlist/type/v2?page=${page}&per_page=${per_page}&search=${search}`)
}

export const GetEquipmentCategoryMasterlist = ({ page = 1, per_page = 10, search = '' }) => {
  return $axios.get(`equipment/category/list/v2?page=${page}&per_page=${per_page}&search=${search}`)
}

export const SaveCategoryData = (data) => {
  return $axios.post(`/equipment/type/create`, data)
}

export const SaveCategoryMasterlist = (data) => {
  return $axios.post(`/equipment/category/create/v2`, data);
}

export const GetEquipmentTypeById = ({ page = 1, per_page = 10, search = '', typeId }) => {
  return $axios.get(`/equipment/category/type-list/v2?page=${page}&per_page=${per_page}&type_id=${typeId}&search=${search}`)
}

export const ArchiveEquipmentCategory = (data) => {
  return $axios.post(`/equipment/archive/type/v2`, data)
}

export const UpdateEquipmentCategory = (data) => {
  return $axios.post(`/equipment/category/update/v2`, data)
}

export const GetEquipmentByCategory = ({ categoryId }) => {
  return $axios.get(`/equipment/model_and_brand/list/v2?category_id=${categoryId}`)
}

export const PostEquipmentArchive = (data) => {
  return $axios.post(`/equipment/archive/v2`, data)
}

export const PostEquipmentRequestV2 = (data) => {
  return $axios.post(`/equipment/request/v2`, { data })
}